import { render, staticRenderFns } from "./DadosMonitoramento.vue?vue&type=template&id=8ebc1f8c&scoped=true&lang=pug"
import script from "./DadosMonitoramento.vue?vue&type=script&lang=js"
export * from "./DadosMonitoramento.vue?vue&type=script&lang=js"
import style0 from "./DadosMonitoramento.vue?vue&type=style&index=0&id=8ebc1f8c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ebc1f8c",
  null
  
)

export default component.exports